import React from 'react';
import {Header} from "@deere/ux.uxframe-react";
import {useOktaAuth, withOktaAuth} from "@okta/okta-react";
import {useSelector} from "react-redux";
import {languageResponseData} from "../Translation/translationSerachSlice";

const WtyReportNoAccessHeader = (props) => {

    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse [key] || defaultText;
    };
    const history = props.history;
    const location = props.location;
    return (<div>
        <Header
            inputProps={{ariaLabel: "Search"}}
            submitBtnProps={{ariaLabel: "Search"}}
            clearBtnProps={{ariaLabel: "Clear search"}}
            logoLinkOnClick={() => {
               // history.push("/");
            }}
            logoLink="/"
            headerTitleComponent={<HeaderDropdown userName={props.userName}/>}
            skipLink="#content" pageHeadingLink="/home"
            pageHeadingLinkOnClick={e => {
                e.preventDefault();
                history.push("/");
            }}
            navbarCustom={true} search={false}
            pageHeading={translate('warrantyreport','Warranty Reports')}
        >
        </Header>
    </div>);
};

const HeaderDropdown = ({userName}) => {
    const translationsResponse = useSelector(languageResponseData);
    const translate = (key, defaultText) => {
        return translationsResponse [key] || defaultText;
    };
    const {oktaAuth} = useOktaAuth();
    return (
        <>
            <span className="uxf-link-text">{translate('hi','Hi')},
                <span className="uxf-header-title-username">{userName}</span></span>
        </>
    )
}

export default withOktaAuth(WtyReportNoAccessHeader);